"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyXGetYProductPromotionPropertiesSchema = exports.BuyXGetYWithXPieceOfSelectedProductInBundlePromotionSettingSchema = exports.BuyXGetYWithXPieceOfSelectedProductPromotionSettingSchema = void 0;
const zod_1 = require("zod");
const typings_1 = require("../../../typings");
const base_1 = require("../base");
const BuyXGetYPromotionCriteriaSchema = base_1.PromotionCriteriaSchema.extend({
    freeProducts: zod_1.z.array(base_1.FreeProductSchema),
    thresholds: zod_1.z.array(base_1.PromotionAmountThresholdSchema),
});
const BaseBuyXGetYPromotionSettingsSchema = base_1.PromotionSettingsSchema.extend({
    criteria: zod_1.z.array(BuyXGetYPromotionCriteriaSchema),
    threshold: (0, base_1.OptionalAndNullishSchema)(base_1.PromotionAmountThresholdSchema),
    type: (0, base_1.isValueMatchedSchema)(zod_1.z.string(), typings_1.PromotionSettingsType.BUY_X_GET_Y),
});
exports.BuyXGetYWithXPieceOfSelectedProductPromotionSettingSchema = BaseBuyXGetYPromotionSettingsSchema.extend({
    condition: (0, base_1.isValueMatchedSchema)(zod_1.z.string(), typings_1.PromotionCondition.BUY_X_PIECE_OF_SELECTED_PRODUCT),
    isBundled: (0, base_1.isValueMatchedSchema)(zod_1.z.boolean(), false),
});
exports.BuyXGetYWithXPieceOfSelectedProductInBundlePromotionSettingSchema = BaseBuyXGetYPromotionSettingsSchema.extend({
    condition: (0, base_1.isValueMatchedSchema)(zod_1.z.string(), typings_1.PromotionCondition.BUY_X_PIECE_OF_SELECTED_PRODUCT_IN_BUNDLE),
    isBundled: (0, base_1.isValueMatchedSchema)(zod_1.z.boolean(), true),
});
exports.BuyXGetYProductPromotionPropertiesSchema = (0, base_1.generatePromotionPropertiesSchemaByPromotionTypeAndItsSettingsSchema)(typings_1.PromotionType.PRODUCT, zod_1.z.union([
    exports.BuyXGetYWithXPieceOfSelectedProductInBundlePromotionSettingSchema,
    exports.BuyXGetYWithXPieceOfSelectedProductPromotionSettingSchema,
]));
//# sourceMappingURL=buy-x-get-y.js.map